$("body").bind("DOMSubtreeModified", function() {
  $(".ssw-fave-product-price").css("display", "none");
  $(".cbb-frequently-bought-container").css("display", "none");
  $(".primeBadges .prime-d-block").css("display", "none");
  $(".mobilephone").css("display", "none");
  $(".cbb-also-bought-container").css("display", "none");
  $(".payment-icons").css("display", "none");
});

function get_country_code() {
    return new Promise((resolve, reject) => {
        var trace = []; 
        jQuery.ajax('/cdn-cgi/trace', {
            success: function(response) {
                var lines = response.split('\n');
                var keyValue;
                for (var index = 0; index < lines.length; index++) {
                    const line = lines[index];
                    keyValue = line.split('=');
                    trace[keyValue[0]] = decodeURIComponent(keyValue[1] || '');
                    if (keyValue[0] === 'loc' && trace['loc'] !== 'XX') {
                        return resolve(trace['loc']);
                    }
                }
            },
            error: function() {
                return reject(trace);
            }
        });

    });
}

get_country_code().then((country_code) => {
  
  var country = country_code;
  var cnt = JSON.stringify(country);
  console.log(country);
  
  if (country == "TR") {
    
  }

  
}).catch((err) => {
    // caught the error, now do something with it
});

// var userLang = navigator.language || navigator.userLanguage; 
// if (userLang != "tr-TR") {
//   alert ("The language is: " + userLang);
//   var prPrice = document.getElementById('ProductPrice');
//   prPrice.remove();
// }

$.get('https://www.cloudflare.com/cdn-cgi/trace', function(data) {
    //console.log(data)
      const myRegexp = /^(?:ip|uag)=(.*)$/gm;
      const myString = data;
      let match;

      let resultString = "";
      match = myRegexp.exec(myString);
      while (match != null) {
        resultString = resultString.concat(match[1] + "\n");
        match = myRegexp.exec(myString);
      }
       console.log(resultString);
})




